<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import ChartNoiseReduction from '$lib/PageSections/Charts/ChartNoiseReduction/ChartNoiseReduction.svelte';
	import CustomerStory from '$lib/PageSections/CustomerStory/CustomerStory.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import ProductRecommendation from '$lib/PageSections/Products/ProductRecommendation.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';
	import TrustedChoice from '$lib/PageSections/TrustedChoice/TrustedChoice.svelte';

	import { SleepProduct } from '$lib/data/products/products-data.js';
	import { sleepPanelCustomerStory } from '$routes/(public)/resources/case-studies/customer-stories.js';

	import closedCurtainsImage from './images/closedCurtains.jpg';
	import getInBedImage from './images/guyInBed.jpg';
</script>

<Section>
	<h2 class="text-left">Blackout Your Windows With Sleep Panels</h2>
	<p class="text-left">
		Whether you're a day-sleeper or struggle with bright street lights at night,
		getting restful sleep can be a challenge if you can't prevent light from
		seeping in through your windows.
	</p>
	<Image src={getInBedImage} loading="eager" />
	<p class="text-left">
		Light seeping in can also be truly painful for those that suffer from
		migraines and other light-sensitive conditions. Others seek darkness for
		their work or even to create a theater room!
	</p>
	<p class="text-left">
		Dark, thick curtains can help, but still allow light to sneak in through the
		cracks, making it difficult to achieve complete darkness.
	</p>

	<Image src={closedCurtainsImage} />

	<h2 class="text-left">Block 100% of Light with Indow Sleep Panels</h2>
	<p class="text-left">
		Achieving total darkness is easy with Indow Sleep Panels. Custom-crafted to
		your exact window dimensions, sleep panels fully block out all light from
		coming in your windows, helping you get the restful reprieve from light
		you're seeking.
	</p>
	<p class="text-left">
		Plus, our sleep panels reduce outside noise coming through your windows by
		up to 50% - helping you tackle the two issues that are most disruptive to a
		sound sleep.
	</p>
</Section>

<CustomerStory story={sleepPanelCustomerStory} />

<Section>
	<h2 class="text-left">More Quiet, More Comfort, More Savings</h2>
	<p class="text-left">
		In addition to blocking 100% of light and reducing noise, <a
			href="/products/sleep-panels">Indow Sleep Panels</a
		>
		also keep your home's temperature more stable, reducing energy use. It's a win-win-win
		for your pocket book, the planet, and your sleep schedule!
	</p>
	<p class="text-left">
		They also <a href="/solutions/prevent-window-condensation"
			>reduces condensation</a
		>
		and
		<a href="/solutions/block-pollen-and-pollutants"
			>blocks dust, pollen, and other airborne particles</a
		>. But that doesn't mean you'll have to live in darkness all the time! With
		a gentle tug on the provided D-ring, you can break the seal and remove the
		inserts whenever you want to open your windows and let in some light.
	</p>
</Section>

<ProductRecommendation product={SleepProduct} />

<Section backgroundColor="grey-light">
	<h3 class="text-indow-grey-dark">Indow vs Replacement Windows</h3>
	<p>
		Adding Indow inserts to an existing window can make your windows perform as
		well (or better!) than a replacement window, but at a fraction of the cost
		and without the hassle and disruption of installing new windows.
	</p>

	<ChartNoiseReduction />
</Section>

<TrustedChoice />
<Reviews />
<GetAFreeEstimate />
